// For more information about this file see https://dove.feathersjs.com/guides/cli/service.shared.html
import type { ClientApplication } from '../../client';
import type {
  FeaturedList,
  FeaturedListData,
  FeaturedListPatch,
  FeaturedListQuery,
  FeaturedListService,
} from './featured-list.class';

export type { FeaturedListPatch, FeaturedListQuery, FeaturedList, FeaturedListData };

export type FeaturedListClientService = Pick<
  FeaturedListService,
  (typeof featuredListMethods)[number]
>;

export const featuredListPath = 'api/featured-list';

// Internal grading/tier lists that live in bbp.list but are not content
// pages — excluded from list menus, related-list overlap, and film-page
// collection rails alike.
export const NON_CONTENT_LIST_IDS = [
  'reference',
  'solid',
  'superior_imports',
  'good_imports',
  'good_in_dv_only',
  'disappointing',
  'worse_than_bd',
];

export const featuredListMethods: Array<keyof FeaturedListService> = [
  'create',
  'patch',
  'remove',
  'addExistingFilm',
  'addNewFilm',
  'getListWithMetadata',
  'getFeaturedLists',
  'getCollections',
];

export const featuredListClient = (client: ClientApplication) => {
  const connection = client.get('connection');

  client.use(featuredListPath, connection.service(featuredListPath), {
    methods: featuredListMethods,
  });
};

// Add this service to the client service type index
declare module '../../client' {
  interface ServiceTypes {
    [featuredListPath]: FeaturedListClientService;
  }
}
